
import api from "../infrastructure/Api";

export const GetMyProfessions = () => async (dispatch) => {
    return await api.getMyProfessions();
}

export const CheckMyProfessionExists = () => async (dispatch) => {
    return await api.checkMyChallengeExists();
}